<template>
  <q-page class="q-pa-md">
    <h1 class="text-h5 text-white">Financial Services</h1>
    <p>We help financial institutions optimize data analytics, security, and automation.</p>
  </q-page>
</template>
